module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Pirkumu grozs")])], 1)]), _vm._v(" "), _c('cart-steps', {
    attrs: {
      "step": "2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui attached segment"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "grouped fields"
  }, [(_vm.cart.details && _vm.missingInAccount >= 0) ? _c('div', [_vm._v("\n           Apliecinu, ka vēlos veikt pasūtījumu par "), _c('b', [_vm._v(_vm._s((_vm.cart.details.total_price_with_bail_and_vat - _vm.cart.details.final_discount_vat).toFixed(2)))]), _vm._v(" €, kas tiks atskaitīts no mana konta\n        ")]) : _c('div', [_vm._v("\n           Kontā pietrūkst "), _c('b', [_vm._v(_vm._s(_vm.missingInAccount) + " €.")]), _vm._v(" Maksāšu ar:\n        "), _vm._l((_vm.paymentMethods), function(item) {
    return (_vm.cart.details.cash_allowed || item.id != 3 && !_vm.cart.details.cash_allowed) ? _c('div', {
      staticClass: "field"
    }, [(((_vm.cart.delivery_type_id != 1 && item.id != 5 && _vm.cart.delivery_type_id != 1 && item.id != 3) || _vm.cart.delivery_type_id == 1) && ((item.id == 5 && _vm.user.pay_later == 1) || (item.id != 5 && _vm.user.pay_later == 0) || (item.id != 5 && _vm.user.pay_later == 1))) ? _c('div', {
      staticClass: "ui radio checkbox"
    }, [(item.id == 5 && _vm.overCreditLimit < 0) ? _c('span', [_c('input', {
      attrs: {
        "type": "radio",
        "name": "payment_type",
        "disabled": ""
      },
      domProps: {
        "checked": false
      }
    }), _vm._v(" "), _c('label', [_c('b', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" Jūsu pasūtījums pārsniedz kredītlimitu " + _vm._s(_vm.user.credit_limit) + " EUR. Lūdzu papildiniet kontu vismaz par EUR " + _vm._s(_vm.overCreditLimit.toFixed(2)) + ".")]), _vm._v(" "), (item.url) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "blank"
      }
    }, [_vm._v("(" + _vm._s(item.urlText) + ")")]) : _vm._e()])]) : _c('span', [_c('input', {
      attrs: {
        "id": item.id,
        "type": "radio",
        "name": "payment_type",
        "number": ""
      },
      domProps: {
        "checked": item.id == _vm.cart.payment_type
      },
      on: {
        "change": function($event) {
          return _vm.updatePaymentMethod(item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.charge > 0) ? _c('span', {
      staticClass: "ms-small-txt"
    }, [_vm._v("(pasūtījuma apstrādes maksa " + _vm._s(item.charge) + " EUR)")]) : _vm._e(), _vm._v(" "), (item.url) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "blank"
      }
    }, [_vm._v("(" + _vm._s(item.urlText) + ")")]) : _vm._e()])])]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.cart.payment_type != 3 && _vm.cart.payment_type != 5 && _vm.cart.payment_type != 2) ? _c('div', {
    staticClass: "inline fields"
  }, [_c('div', [_vm._v("Papildus šim pasūtījumam vēlos iemaksāt avansu   ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    attrs: {
      "type": "number",
      "step": "1",
      "number": ""
    },
    domProps: {
      "value": _vm.cart.top_up
    },
    on: {
      "change": function($event) {
        return _vm.updateTopUpAmount($event.target.value)
      }
    }
  }), _vm._v(" €\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.user.bonus > 0 && _vm.cart.details && _vm.cart.details.total_price_with_bail_and_vat - _vm.cart.details.final_discount_vat > 0 && _vm.cart.details.no_water_goods_price_vat > 0) ? _c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    attrs: {
      "id": "use_bio",
      "type": "checkbox",
      "value": "1",
      "number": ""
    },
    domProps: {
      "checked": _vm.cart.use_bonus
    },
    on: {
      "change": function($event) {
        return _vm.updateBonusStatus($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#21BA45"
    },
    attrs: {
      "for": "use_bio"
    }
  }, [_vm._v("\n\t\t\tVēlos izmantot bonusu BIO produktu iegādei. Mans kopējais uzkrājums "), _c('b', [_vm._v(_vm._s(_vm.user.bonus) + " €")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("*Līdz 30% no kopējās produktu summas.")])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui buttons"
  }, [_c('button', {
    staticClass: "ui button",
    class: {
      disabled: _vm.showLoading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_vm._v("Atpakaļ")]), _vm._v(" "), _c('div', {
    staticClass: "or",
    attrs: {
      "data-text": "vai"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui custom_brown button",
    class: {
      loading: _vm.showLoading, disabled: _vm.missingInAccount < 0 && _vm.cart.payment_type == 2
    },
    on: {
      "click": _vm.processCart
    }
  }, [_vm._v("Apmaksāt")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "0",
      "height": "0",
      "visibility": "hidden"
    },
    attrs: {
      "id": "cart_total_price_with_bail_and_vat"
    }
  }, [_vm._v(_vm._s(_vm.cart.details.total_price_with_bail_and_vat))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6706d676!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartPaymentPage.vue
// module id = 354
// module chunks = 1